import React from 'react';
import PropTypes from 'prop-types';
import { Select } from '@chakra-ui/react';
import { MdArrowDropDown } from 'react-icons/md';

export default function DeptSelect({ children, ...rest }) {
  return (
    <Select
      icon={<MdArrowDropDown />}
      borderRadius="lg"
      rootProps={{ py: 2 }}
      textStyle="body"
      fontSize="1rem"
      {...rest}
    >
      {children}
    </Select>
  );
}

DeptSelect.propTypes = {
  children: PropTypes.node.isRequired,
};
